import { Clock, Effect, Schema as S } from "effect";

import { localIsoDate } from "../../widgets/addEntry";
import { defineApi } from "../client";
import { Week } from "../schemas/keepInTouch";
import { Cadence } from "../schemas/records";

/** KTD4: the viewer's local calendar date, taken from the Clock at issue time. */
const today = Clock.currentTimeMillis.pipe(
	Effect.map((millis) => localIsoDate(new Date(millis))),
);

export const getWeek = defineApi("GetWeek", {
	args: { today: S.String },
	response: Week,
	request: ({ today }) => ({
		method: "GET",
		path: "/keep-in-touch",
		query: { today },
	}),
});

/** The writes answer with the refreshed week or `{ ok: true }`; callers refetch, so the body is not decoded. */
export const skipCard = defineApi("SkipCard", {
	args: { recordId: S.String, today: S.String },
	response: S.Unknown,
	request: (body) => ({ method: "POST", path: "/keep-in-touch/skip", body }),
});

export const swapCard = defineApi("SwapCard", {
	args: {
		recordId: S.String,
		today: S.String,
		replacementId: S.NullOr(S.String),
	},
	response: S.Unknown,
	request: ({ recordId, today, replacementId }) => ({
		method: "POST",
		path: "/keep-in-touch/swap",
		body: {
			recordId,
			today,
			...(replacementId === null ? {} : { replacementId }),
		},
	}),
});

export const setCadence = defineApi("SetCadence", {
	args: {
		recordId: S.String,
		cadence: S.NullOr(Cadence),
		paused: S.Boolean,
	},
	response: S.Unknown,
	request: (body) => ({ method: "POST", path: "/keep-in-touch/cadence", body }),
});

export const fetchWeek = today.pipe(
	Effect.flatMap((today) => getWeek.run({ today })),
);

export const skip = (recordId: string) =>
	today.pipe(Effect.flatMap((today) => skipCard.run({ recordId, today })));

export const swap = (recordId: string, replacementId: string | null) =>
	today.pipe(
		Effect.flatMap((today) => swapCard.run({ recordId, today, replacementId })),
	);
